import React, { useEffect, useRef, useState } from 'react';
import { GridView } from '@vivli/shared/views';
import {ColDef, GridApi, ICellRendererParams} from 'ag-grid-community';
import { IDataRequestActionDetailDto, IDisclosureActionDetailDto } from '@vivli/features/dashboard/infrastructure/interface';
import { DisclosureActionCardView } from '@vivli/features/dashboard/views';
import { actionGridContainerStyle } from './actions-grids-styles';

interface DisclosureActionsGridComponentProps {
    onGridReady?: (gridApi: GridApi) => void;
    emptyMessage?: string;
    hideFloatingFilter?: boolean;
    hideHeader?: boolean;
    autoHeight?: boolean;
    dataRefreshing?: boolean;
    dtos?: IDisclosureActionDetailDto[];
}

export const DisclosureActionsGridComponent = ({
    onGridReady,
    dataRefreshing,
    dtos,
}: DisclosureActionsGridComponentProps) => {
    const [rowData, setRowData] = useState<IDisclosureActionDetailDto[]>();
    const gridApiRef = useRef<GridApi>();

    const handleOnGridReady = (gridApi: GridApi) => {
        onGridReady && onGridReady(gridApi);
        gridApiRef.current = gridApi;
    };

    const columnDefs: ColDef[] = [
        {
            field: 'vivliId',
            headerName: 'ID',
            filter: true,
            sortable: true,
            maxWidth: 140,
        },
        {
            field: 'title',
            headerName: 'Disclosure Title',
            filter: true,
            sortable: true,
            maxWidth: 250,
        },
        {
            field: 'leadInvestigatorFullName',
            headerName: 'Lead Investigator',
            filter: true,
            sortable: true,
            valueGetter: ({ data }) => `${data?.leadInvestigatorFirstName} ${data?.leadInvestigatorLastName}`,
        },
        {
            field: 'daysLeft',
            headerName: '30-Day Review',
            filter: true,
            sortable: true,
            maxWidth: 140,
        },
        {
            field: 'disclosureType',
            headerName: 'Disclosure Type',
            filter: true,
            sortable: true,
            maxWidth: 150,
        },
        {
            field: 'contributors',
            headerName: 'Data Contributors',
            filter: true,
            sortable: true,
            valueGetter: ({ data }) => (data?.contributors ?? []).join(', '),
        },
        {
            field: 'actionText',
            headerName: 'Action Required',
            filter: true,
            sortable: true,
            hide: false,
            maxWidth: 250,
        },
    ];

    const getFullWidthRenderer = ({ data }: ICellRendererParams<IDataRequestActionDetailDto>) => (
        <DisclosureActionCardView dto={data}></DisclosureActionCardView>
    );

    useEffect(() => {
        if ((!dtos || dtos.length === 0) && !dataRefreshing) {
            return;
        }

        setRowData(dtos);
    }, [dtos, dataRefreshing]);

    return (
        <div style={actionGridContainerStyle}>
            <GridView
                rowData={rowData}
                useFullWidthRows={true}
                onGridReady={handleOnGridReady}
                fullWidthCellRenderer={getFullWidthRenderer}
                columns={columnDefs}
                rowHeight={130}
            />
        </div>
    );
};
